import script from "./Banners.vue?vue&type=script&setup=true&lang=js"
export * from "./Banners.vue?vue&type=script&setup=true&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=05010520&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05010520"]])

export default __exports__